/**
 * Turns a paginated axios request endpoint into an async generator so that you can easily get every page of results.
 *
 * Takes a function that takes a startKey and returns an axios request that must include a lastEvaluatedKey in the response.
 * If lastEvaluatedKey is not returned, it assumes that this is the last page of results.
 */
export function getAllFromPagination(getAllPaginated) {
    async function* paginate(startKey) {
        do {
            const response = await getAllPaginated(startKey);
            if (response.data.lastEvaluatedKey === startKey && startKey)
                throw new Error('Last evaluated key did not change between pages. Pagination broken');
            startKey = response.data.lastEvaluatedKey;
            yield response;
        } while (startKey);
    }
    return paginate;
}
export async function aggregatePaginationResponse(asyncGenerator, selector) {
    let data = [];
    for await (const page of asyncGenerator) {
        data = data.concat(selector(page.data));
    }
    return data;
}
